import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { clientQuery, clientMutation } from '../../../../../../../config/helpers/GraphQLApi';

import { endpoints } from '../../../../../../../config/constants';
import { ExceptionManager } from '../../../../../../../config/helpers/Logging'
import { resetALL } from '../../../../../../../config/redux/actions'

//STATE INITIAL
const INIT_STATE = {
    loading: false,
    data: null,
    error: null,
    //
    loadingDelete: false,
    errorDelete: null,
    successDelete: null,
};

const route = 'modules/management/parameters/components/templates/slice'

//Extend async Action
export const campaignTemplateListSearch = createAsyncThunk('parameter/campaignTemplateListSearch', async (
    { searchText, limit, offset, typeId = null },
    { rejectWithValue, dispatch }
) => {
    try {
        let data = await clientQuery(
            `query searchCampaignsTemplate($searchText: String, $limit: Int, $offset: Int, $typeId: Int) {
                result: searchCampaignsTemplate(searchText: $searchText, limit: $limit, offset: $offset, typeId: $typeId) {
                    items {
                        id
                        name
                        subject
                        body
                        createdOn
                        createdBy
                    }
                    count
                }
            }`,
            {
                searchText: searchText || '',
                limit: limit || 10,
                offset: offset || 0,
                typeId
            },
            endpoints.GRAPHQL_GENERAL
        );
        return data?.result || []

    } catch (exc) {
        ExceptionManager(exc, route, 'campaignTemplateListSearch', dispatch);
        return rejectWithValue(exc)
    }
})
export const campaignTemplateDelete = createAsyncThunk('parameter/campaignTemplateDelete', async (
    { id },
    { rejectWithValue, dispatch }
) => {
    try {
        let data = await clientMutation(
            `mutation deleteCampaignsTemplate($id: Int!){
                result: deleteCampaignsTemplate(id: $id)
            }`,
            {
                id
            },
            endpoints.GRAPHQL_GENERAL
        );


        return data?.result

    } catch (exc) {
        ExceptionManager(exc, route, 'deleteCampaignsTemplate', dispatch);
        return rejectWithValue(exc)
    }
})
//Slice
const templatesListRedux = createSlice({
    name: 'parameters/list/templates',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE)

        builder.addCase(campaignTemplateListSearch.pending, (state) => {
            state.loading = true
        })
        builder.addCase(campaignTemplateListSearch.fulfilled, (state, { payload }) => {
            state.loading = false
            state.data = payload
        })
        builder.addCase(campaignTemplateListSearch.rejected, (state, action) => {
            state.loading = false
            state.error = action.error.message
        })

        // delete compaign from
        builder.addCase(campaignTemplateDelete.pending, (state) => {
            state.loadingDelete = true
        })
        builder.addCase(campaignTemplateDelete.fulfilled, (state, { payload }) => {
            state.loadingDelete = false
            state.successDelete = payload
        })
        builder.addCase(campaignTemplateDelete.rejected, (state, action) => {
            state.loadingDelete = false
            state.errorDelete = action.error.message
        })
    },
})

// Extract and export the action creators object and the reducer
export const { actions, reducer } = templatesListRedux;

// Extract and export each action creator by name
export const { reset } = actions

//Simple async action

// Export the reducer, either as a default or named export
export default reducer